import {
  LOGIN_REQUEST,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  LOGOUT,
} from "./types";
import axios from "axios";
import { setAlert } from "./alertActions";

export const login = (email, password) => async (dispatch) => {
  dispatch({ type: LOGIN_REQUEST });

  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ email, password });

    const response = await axios.post(
      "https://bekeeper.onrender.com/users/login",
      body,
      config
    );

    const token = response.data.token;
    localStorage.setItem("token", token);

    dispatch({ type: LOGIN_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response.data.message;
    dispatch({ type: LOGIN_FAILED, payload: errorMessage });
    dispatch(setAlert(errorMessage, 5));
    console.error(error);
  }
};

export const register = (email, name, phone, password) => async (dispatch) => {
  dispatch({ type: REGISTER_REQUEST });

  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ name, email, phone, password });
    const resp = await axios.post(
      "https://bekeeper.onrender.com/users/register",
      body,
      config
    );

    const token = resp.data.token;
    localStorage.setItem("token", token);
    dispatch({ type: REGISTER_SUCCESS, payload: resp.data });
  } catch (error) {
    const errorMessage = error.response.data.message;
    dispatch({ type: REGISTER_FAILED, payload: errorMessage });
    dispatch(setAlert(errorMessage));
    console.error(error);
  }
};

export const logout = () => (dispatch) => {
  dispatch({ type: LOGOUT });
};
